import React, { useState, useCallback, useContext, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import './Style.css';
import AccessDenied from '../../shared/components/accessDenied/AccessDenied';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../../shared/context/auth-context';
import { Header } from '../../shared/headerNavigation/header/Header';
import { useAuth } from '../../shared/hooks/auth-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { useMedia } from '../../shared/hooks/media-hook';
import { useUserData } from '../../shared/hooks/useUserData';
import Modal from '../../shared/modal/Modal';
import SideMenu from '../menu/Menu';
import CoRepFilter from './components/CoRepFilter';
import Campaigns from './sections/CampaignsComms';
import Engagement from './sections/EngagementResources';
import ErvImport from './sections/ErvImport';
import HealthWellbeing from './sections/HealthWellbeingStrategy';
import Leadership from './sections/LeadershipLab';
import LiveAnalytics from './sections/LiveAnalytics';
import Partners from './sections/PartnersProviders';
import UsageStatistics from './sections/UsageStatistics';

export function CompanyReport() {
  const { isLoading, sendRequest } = useHttpClient();
  const { userData } = useUserData();

  const { tags } = useAuth();
  const { openMediaModal, favourites, progressList, scrolled } = useMedia();
  const auth = useContext(AuthContext);

  const [threshold, setThreshold] = useState(15);
  const [scores, setScores] = useState();
  const [coData, setCoData] = useState();
  const [usage, setUsage] = useState();
  const [companyName, setCompanyName] = useState();
  const [reportPeriod, setReportPeriod] = useState();

  const [days, setDays] = useState(30);
  const [filtersArr, setFiltersArr] = useState([]);
  const [allowedFilters, setAllowedFilters] = useState();
  const [filterSnapshot, setFilterSnapshot] = useState();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getDataForSetPeriod = (period) => {
    // setFiltersArr([]);
    fetchData(period);
  };

  const fetchData = async (period) => {
    try {
      const formData = new FormData();
      formData.append('userid', auth.userId);
      formData.append('filtersArr', filtersArr);
      formData.append('periodid', period);
      formData.append('days', days);
      if (queryParams.get('requestedClientId')) {
        formData.append('requestedClientId', queryParams.get('requestedClientId'));
      }

      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/assessments/datarequest`,
        'POST',
        formData,
        {} // Keep to ensure it ensure doesn't send Content-Type
      );
      if (responseData) {
        if (responseData?.leadership_threshold) {
          setThreshold(responseData.leadership_threshold);
        }
        setScores(responseData.scores);
        // if (!period && !coData) {
        setCoData(responseData.codata);
        // }
        setUsage(responseData.usagedata);
        setCompanyName(responseData.client_name);
        // check current report period if different or no filters
        // setFiltersArr(responseData.codata.applied_filters);
        if (
          (filtersArr.length < 1 && !allowedFilters) ||
          (filtersArr.length < 1 && !reportPeriod) ||
          (filtersArr.length < 1 && reportPeriod && reportPeriod !== responseData.report_period) ||
          responseData.codata.applied_filters.length < 1
        ) {
          setAllowedFilters(responseData.codata.allowed_filters);
        }
        setReportPeriod(responseData.codata.report_period);
      }
    } catch (err) {}
  };

  const { pageid } = useParams();
  const { subpageid } = useParams();

  useEffect(() => {
    if (pageid !== 'live-analytics' || !auth.userId) return;
    fetchData();
    // fetchData is re-created every render and sets the state it reads, so
    // depending on it would loop the main report fetch. The listed deps are
    // the deliberate refetch triggers.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageid, days, filtersArr, auth]);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTextContent, setModalTextContent] = useState('');

  const modalClickHandler = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const openModal = useCallback((props) => {
    const modalText =
      props ||
      'If engagement is low and you would like to extend your health assessment window, please contact one of the Champion team.';
    setModalIsOpen(true);
    // if (typeof props === "object") {
    //   props = "Not currently available.";
    // }
    setModalTextContent(modalText);
  }, []);

  const filterChangeHandler = useCallback((props) => {
    if (props.days) {
      setDays(props.days);
    } else if (props.filtersArr || props.filtersArr.length === 0) {
      setFiltersArr(props.filtersArr);
    }
  }, []);

  window.onscroll = function handleWindowScroll() {
    const scrollPosition =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if (document.getElementsByClassName('scrollLinks').length > 0) {
      if (scrollPosition > 160) {
        document.getElementsByClassName('scrollLinks')[0].classList.add('scrolled');
      } else {
        document.getElementsByClassName('scrollLinks')[0].classList.remove('scrolled');
      }
    }
  };

  useEffect(() => {
    if (scrolled) {
      window.scrollTo(0, scrolled);
    }
  }, [scrolled]);

  const onChangeSliderPos = (props) => {
    const current = sliderPos;
    current[props.id] = props.pos;
    setSliderPos(current);
  };

  const [sliderPos, setSliderPos] = useState({});

  // filter
  const [filterOpen, setFilterOpen] = useState(false);

  const toggleFilterOpen = () => {
    setFilterOpen(!filterOpen);
  };

  const filterSelectHandler = (selectedFiltersArr, filterObj) => {
    filterChangeHandler({ filtersArr: selectedFiltersArr });
    setFilterSnapshot(filterObj);
    if (selectedFiltersArr.length > 0) {
      setFilterOpen(false);
      window.scrollTo(0, 0);
    }
  };

  const clearFilterArr = () => {
    setFiltersArr([]);
  };

  return (
    <div id="main_container" className="reports company_report">
      {filterOpen && (
        <CoRepFilter
          threshold={threshold}
          coData={coData}
          filterSelectHandler={filterSelectHandler}
          getDataForSetPeriod={getDataForSetPeriod}
          toggleFilterOpen={toggleFilterOpen}
          filtersArr={filtersArr}
          allowedFilters={allowedFilters}
          filterSnapshot={filterSnapshot}
          clearFilterArr={clearFilterArr}
        />
      )}
      {modalIsOpen && (
        <Modal
          modalIsOpen={modalIsOpen}
          onModalClose={modalClickHandler}
          modalText={modalTextContent}
        />
      )}
      <Header page="company" type="transparent" />
      {parseInt(auth.access, 10) > 2 && !auth.isHub ? (
        <>
          <div id="left_container">
            <SideMenu
              coData={coData}
              showLiveAnalyticsOnly={!!queryParams.get('requestedClientId')}
            />
          </div>
          <div id="right_container">
            {pageid === 'live-analytics' && !scores && <LoadingSpinner asOverlay />}

            {pageid === 'live-analytics' && !subpageid && scores && coData && (
              <LiveAnalytics
                disableFilters={userData?.customFeatureClient === 'pam'}
                threshold={threshold}
                onOpenModal={openModal}
                scores={scores}
                onOpenMediaModal={openMediaModal}
                coData={coData}
                onFilterChange={filterChangeHandler}
                usage={usage}
                reportPeriod={reportPeriod}
                getDataForSetPeriod={getDataForSetPeriod}
                isLoading={isLoading}
                filtersArr={filtersArr}
                toggleFilterOpen={toggleFilterOpen}
                filterOpen={filterOpen}
                companyName={companyName}
              />
            )}
            {pageid === 'usage-statistics' && !subpageid && (
              <UsageStatistics
                threshold={threshold}
                onOpenModal={openModal}
                data={scores}
                onOpenMediaModal={openMediaModal}
                coData={coData}
                onFilterChange={filterChangeHandler}
                usage={usage}
                reportPeriod={reportPeriod}
              />
            )}
            {pageid === 'campaigns-communications' && !subpageid && (
              <Campaigns
                onOpenModal={openModal}
                scores={scores}
                onOpenMediaModal={openMediaModal}
              />
            )}
            {pageid === 'engagement-resources' && !subpageid && (
              <Engagement
                onOpenModal={openModal}
                scores={scores}
                onOpenMediaModal={openMediaModal}
              />
            )}
            {pageid === 'health-wellbeing-strategy' && !subpageid && (
              <HealthWellbeing
                onOpenModal={openModal}
                scores={scores}
                onOpenMediaModal={openMediaModal}
                coData={coData}
              />
            )}
            {pageid === 'leadership-lab' && !subpageid && (
              <Leadership
                onOpenModal={openModal}
                scores={scores}
                onOpenMediaModal={openMediaModal}
                tags={tags}
                favourites={favourites}
                progressList={progressList}
                sliderPos={sliderPos}
                onChangeSliderPos={onChangeSliderPos}
                scrolled={scrolled}
              />
            )}
            {pageid === 'partners-providers' && !subpageid && (
              <Partners onOpenModal={openModal} scores={scores} onOpenMediaModal={openMediaModal} />
            )}
            {pageid === 'erv-import' && !subpageid && <ErvImport coData={coData} />}
          </div>
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}
